import React, { ComponentProps } from 'react'
import { FieldWrapperUi } from './ui/field-wrapper-ui'

interface FieldWrapperProps extends ComponentProps<typeof FieldWrapperUi> {}

export const FieldWrapper = ({ children, ...props }: FieldWrapperProps) => {
  return <FieldWrapperUi {...props}>{children}</FieldWrapperUi>
}
